if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initModal();
	});
} else {
	initModal();
}

function initModal() {
	const CSS_CLASS_BODY_OVERFLOW = 'overflow-hidden';

	document.querySelectorAll('.js-dialog-modal').forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			let identifier = item.getAttribute('data-modal-id') || item.getAttribute('href')?.replace('#', '');
			let dialog = document.getElementById(identifier);
			if(!dialog) return;
			dialog.showModal();
			addBodyOverflow();
			dialog.addEventListener('cancel', event => removeBodyOverflow());
			dialog.addEventListener('click', function(e){
				if (e.target === this) {
					this.close();
					removeBodyOverflow();
				}
			});
		});
	});

	document.querySelectorAll('.js-dialog-close').forEach(item => {
		item.addEventListener('click', event => {
			event.preventDefault();
			let dialog = item.closest('dialog');
			dialog.classList.add('hide');
			dialog.addEventListener('animationend', function handler(){
				dialog.classList.remove('hide');
				dialog.close();
				removeBodyOverflow();
				dialog.removeEventListener('animationend',  handler, false);
			}, {once: true});
		});
	});

	function addBodyOverflow() {
		document.body.classList.add(CSS_CLASS_BODY_OVERFLOW);
	}

	function removeBodyOverflow() {
		document.body.classList.remove(CSS_CLASS_BODY_OVERFLOW);
	}
}
